import { render, staticRenderFns } from "./event-list-page.vue?vue&type=template&id=28261121&"
import script from "./event-list-page.vue?vue&type=script&lang=js&"
export * from "./event-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports